import React from "react";
import "./ProgressBar.css";

/**
 * Determinate progress / completion bar — surface-aware (track + fill read
 * brand semantic vars). The animated "generation" bar in the AI-create flow is
 * a specialized variant; this is the general primitive (e.g. clue completion on
 * a game card).
 *
 * Props:
 *   value:   0–100
 *   tone:    "accent" | "gold" | "warn" | "lava"   (default "accent")
 *            "lava" = a slow floating teal/gold lava-lamp fill (looks best with
 *            a taller height, e.g. 14). Respects prefers-reduced-motion.
 *   height:  px (default 8)
 *   label:   optional caption under the bar
 */
const ProgressBar = ({ value = 0, tone = "accent", height = 8, label, className = "" }) => {
  const pct = Math.min(100, Math.max(0, Number(value) || 0));
  return (
    <div className={`gx-progress ${className}`}>
      <div className="gx-progress-track" style={{ height }} role="progressbar"
        aria-valuenow={Math.round(pct)} aria-valuemin={0} aria-valuemax={100}>
        <div className={`gx-progress-fill tone-${tone}`} style={{ width: `${pct}%` }} />
      </div>
      {label && <div className="gx-progress-label">{label}</div>}
    </div>
  );
};

export default ProgressBar;
